export function SessionMeta(props: { roundIndex: number; rounds: number; workSec: number; restSec: number }) {
    return (
        <div className="text-center">
            <div className="text-xs font-semibold tracking-[0.18em] text-[var(--muted)]">
                ROUND {Math.min(props.roundIndex + 1, props.rounds)} / {props.rounds}
            </div>
            <div className="mt-1 text-[12px] text-[var(--muted)]">
                {props.workSec}s Work / {props.restSec}s Rest
            </div>
        </div>
    );
}
